import React, { FC, memo } from 'react';
import ReactLoading from 'react-loading';

interface Props {
  isLoading: boolean;
  heightSize: number;
  isOverall: boolean;
}

const CustomLoading: FC<Props> = ({ isLoading, heightSize, isOverall }) => {
  return (
    <>
      {isLoading ? (
        <>
          {isOverall ? (
            <>
              <div className="loading-layout-overall">
                <div className="loading-layout-overall-content">
                  <ReactLoading type="spokes" color="#636f83" height={150} width={150} />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="loading-layout" style={{ height: `${heightSize}vh` }}>
                <div className="loading-layout-content">
                  <ReactLoading type="spokes" color="#636f83" height={150} width={150} />
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default memo(CustomLoading);
